import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/common.scss'
import axios from './util/axios'
import storage from './util/storage'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import {getTime} from "@/util/date";

// import store from './store'
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (!storage.get('token') && to.meta.login == 1) {
        storage.set('frompath', to.path)
        next({path: "/login", replace: true})
    }
    next()
})

router.afterEach((to, from) => {

})

const goPage = function (url) {
    router.push(url);
}

const exportData = function (url, param, fileName) {
    axios({
        url: url,
        data: param,
        responseType: 'blob',
        timeout: 100000
    }).then(res => {
        let blob = new Blob([res]);
        if ("download" in document.createElement("a")) {
            // 不是IE浏览器
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
        } else {
            // IE 10+
            window.navigator.msSaveBlob(blob, fileName);
        }
    })
}

const saveInfo = function (infoName) {
    return new Promise((resolve) => {
        // this.tempInfo = {}
        // for (let item in this[infoName]) {
        //   this.tempInfo[item] = this[infoName][item];
        // }
        // this.tempInfo = Object.assign({}, this[infoName])
        this.tempInfo = JSON.parse(JSON.stringify(this[infoName]));
        // this.tempInfo = structuredClone(this[infoName]);
        resolve()
    })
}
const resetInfo = function (infoName) {
    console.log(infoName)
    const temp = JSON.parse(JSON.stringify(this.tempInfo));
    for (let item in this[infoName]) {
        this[infoName][item] = temp[item]
    }
}

const isMobile = function () {
    return /Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(
        navigator.userAgent
    );
}

const getCommonInfo = function (options) {
    return new Promise((resolve) => {
        axios({
            url: '/base/getCommonInfo',
            data: {
                info: options
            },
            showInfo: 0
        }).then(res => {
            if (res.status === 1) {
                for (let item of options) {
                    this[item] = res[item];
                }
                resolve()
            }
        })
    })
}

const getEditInfo = function (id, table, fields, link = []) {
    return new Promise((resolve) => {
        axios({
            url: '/base/getEditInfo',
            data: {
                id: id,
                table: table,
                field: fields,
                link: link
            },
            showInfo: 0
        }).then(res => {
            if (res.status === 1) {
                resolve(res.detail)
            }
        })
    })
}

const getArrayInfo = function (fields, res = []) {
    return new Promise((resolve) => {
        for (let item of fields) {
            if (item.array && item.array !== '') {
                res.push(item.array)
            }
        }
        if (res.length === 0) {
            resolve({
                result: [],
            })
            return;
        }
        res = Array.from(new Set(res));
        axios({
            url: '/base/getArrayInfo',
            data: {
                info: res
            },
            showInfo: 0
        }).then(async rest => {
            if (rest.status === 1) {
                let result = {};
                for (let item in rest.res) {
                    if (rest.res[item]) {
                        sessionStorage.setItem(item,JSON.stringify(rest.res[item]));
                        // await storage.set(item, rest.res[item]);
                        result[item] = rest.res[item];
                    }
                }
                resolve(result)
            }
        })
    })
}

const getFields = function (table) {
    return new Promise((resolve, reject) => {
        // const fields = storage.get(table+'Fields');
        // if(fields){
        //     resolve(fields);
        //     return;
        // }
        axios({
            url: '/table/getTableFields',
            data: {
                table: table,
            },
            showInfo: 0
        }).then((res) => {
            if (res.status === 1) {
                storage.set(table + 'Fields', res.list);
                resolve(res.list)
            }
        })
    })
}

const getUploadUrl = function (url) {
    return window.host + '/' + window.app + url
}

const pic = function (url, refresh = false) {
    if (!url) return '';
    return (window.useOSS === 0 ? (window.localHost + url) : (window.ossHost + url)) + (refresh ? '?' + new Date().getTime() : '');
}

const picList = function (arr, key = null) {
    let temp = [];
    arr.forEach(item => {
        const url = key === null ? item : item[key];
        if (url) {
            temp.push(pic(url))
        }
    })
    return temp;
}

const getQueryParams = function (key) {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(key);
}

const hideloading = function () {
    this.loading = false
}
const showloading = function () {
    this.loading = true
}

const handleCurrentChange = function (p) {
    this.page = p;
    this.getList();
}
const handleSizeChange = function (size) {
    console.log(size)
    this.pagesize = size;
    this.page = 1;
    this.getList();
}

const debounce = function (fn, delay = 500) {
    let timer = null
    return function (...args) {
        if (timer != null) {
            clearTimeout(timer)
            timer = null
        }
        timer = setTimeout(() => {
            fn.call(this, ...args)
        }, delay);
    }
}

const getRemoteOptions = function (query, options, type = 'keyword') {
    return new Promise((resolve) => {
        if (typeof query === 'object') {
            query = query.join(',')
        }
        if (query === '') {
            resolve([])
            return;
        }
        axios({
            url: '/base/getRemoteOptions',
            data: {
                array: options,
                [type]: query
            },
            showInfo: 0
        }).then(res => {
            if (res.status === 1) {
                resolve(res.list)
            }
        })
    })
}

const getRemoteEmployeeList = function (query, options) {
    return new Promise((resolve) => {
        if (query === '') {
            resolve([])
            return;
        }
        const param = {
            array:options,
            ...query
        }
        axios({
            url: '/base/getRemoteOptions',
            data: param,
            showInfo: 0
        }).then(res => {
            if (res.status === 1) {
                resolve(res.list)
            }
        })
    })
}

const getEditFields = function (table) {
    return new Promise((resolve) => {
        axios({
            url: '/base/getEditFields',
            data: {
                table: table,
            },
            showInfo: 0
        }).then(async res => {
            if (res.status === 1) {
                // this[table+'EditFields'] = res.fields;
                resolve({
                    fields: res.fields,
                    result: await getArrayInfo(res.fields)
                })
            }
        })
    })
}
const getShowFields = function (table,getInfo=false) {
    return new Promise((resolve) => {
        axios({
            url: '/base/getShowFields',
            data: {
                table: table,
            },
            showInfo: 0
        }).then(async res => {
            if (res.status === 1) {
                if(getInfo){
                    await getArrayInfo(res.fields)
                    resolve(res.fields)
                }else{
                    resolve(res.fields)
                }
            }
        })
    })
}

const getTableFields = function (table){
    return new Promise((resolve) => {
        axios({
            url: '/base/getTableFields',
            data:{
                table: table,
            },
            showInfo:0
        }).then(res=>{
            resolve(res)
        })
    })
}

const getInfoItem = function (fields, res = {id: ''}) {
    return new Promise(async (resolve) => {
        for (let item of fields) {
            if (Object.keys(res).includes(item.value)) {
                continue;
            }
            switch (item.type) {
                case 'diyselect':
                case 'selectnumber':
                    if (item.multiple === 1) {
                        res[item.value] = [];
                    } else {
                        res[item.value] = ["''", ''].includes(item.defaultValue) ? '' : parseInt(item.defaultValue);
                    }
                    break;
                case 'select':
                    if (item.multiple === 1) {
                        res[item.value] = [];
                    } else {
                        res[item.value] = item.defaultValue === "''" ? '' : item.defaultValue;
                    }
                    break;
                case 'cascader':
                case 'cascadernumber':
                case 'image':
                case 'file':
                    res[item.value] = [];
                    break;
                case 'daterange':
                    res[item.value] = [getTime(), getTime()];
                    res[item.value + '_text'] = '';
                    res[item.value + '_start'] = '';
                    res[item.value + '_end'] = '';
                    break;
                case 'int':
                    res[item.value] = ["''", ''].includes(item.defaultValue) ? '' : parseInt(item.defaultValue);
                    break;
                default:
                    res[item.value] = '';
            }
        }
        resolve(res)
    })
}

const exeFunc = function (func) {
    return function () {
        func()
    }
}

const getStorageData = async (options) => {
    for (let item of options) {
        this[item] = await storage.get(item);
    }
}

const baseController = (controller,params={})=>{
    return new Promise((resolve) => {
        axios({
            url:'/base/baseController',
            data:{
                controller: controller,
                params: params
            },
            showInfo:0
        }).then(res=>{
            resolve(res)
        })
    })
}

// storage.set('targetUnitList',{
// {
//     label:'元',
// }
// })

app.config.globalProperties.tempInfo = {}
app.config.globalProperties.isMobile = isMobile()
app.config.globalProperties.HOST = window.host
app.config.globalProperties.loading = false
app.config.globalProperties.page = 1
app.config.globalProperties.total = 0
app.config.globalProperties.formLabelWidth = '120px'
app.config.globalProperties.pagesizes = ['10', '20', '50', '100', '1000']
app.config.globalProperties.pagesize = 10
app.config.globalProperties.layout = isMobile() ? 'prev, pager, next' : 'total, sizes, prev, pager, next, jumper'
app.config.globalProperties.getArray = false
app.config.globalProperties.diyArray = []
app.config.globalProperties.optionsShow = []
app.config.globalProperties.crntArray = ''
app.config.globalProperties.propList = {}
app.config.globalProperties.tableSetting = {}
app.config.globalProperties.timerangeShortcuts = [
    {
        text: '本周',
        value: [getTime('toweek', 'start'), getTime()],
    },
    {
        text: '上周',
        value: [getTime('lastweek', 'start'), getTime('lastweek')],
    },
    {
        text: '本月',
        value: [getTime('tomonth', 'start'), getTime()],
    },
    {
        text: '上月',
        value: [getTime('lastmonth', 'start'), getTime('lastmonth')],
    }
]

app.mixin({
    methods: {
        $axios: axios,
        $setStorage: storage.set,
        $getStorage: storage.get,
        $removeStorage: storage.remove,
        $clearStorage: storage.clear,
        $goPage: goPage,
        $exportData: exportData,
        $saveInfo: saveInfo,
        $resetInfo: resetInfo,
        $getCommonInfo: getCommonInfo,
        $getUploadUrl: getUploadUrl,
        $pic: pic,
        $picList: picList,
        $hideloading: hideloading,
        $showloading: showloading,
        $handleCurrentChange: handleCurrentChange,
        $handleSizeChange: handleSizeChange,
        $debounce: debounce,
        $getFields: getFields,
        $getArrayInfo: getArrayInfo,
        $getEditInfo: getEditInfo,
        $getQueryParams: getQueryParams,
        $getRemoteOptions: getRemoteOptions,
        $getRemoteEmployeeList: getRemoteEmployeeList,
        $getInfoItem: getInfoItem,
        $getEditFields: getEditFields,
        $exeFunc: exeFunc,
        $getShowFields: getShowFields,
        $getStorageData: getStorageData,
        $baseController:baseController,
        $getTableFields:getTableFields
    }
})

app.use(ElementPlus, {
    locale: zhCn,
})


app.use(router).mount('#app')
